export default "__VITE_ASSET__D1TzGMqY__"